import { createFileRoute, redirect } from "@tanstack/react-router";
import { MarketingContentPage } from "../components/marketing/MarketingContentPage";
import { contentHead, loadContentPage } from "../marketing-content/load";
import { publicRedirectPath } from "../marketing-content/legacy";

// Comparison articles moved to /blog; only the AI employees hub still lives here.
export const Route = createFileRoute("/compare_/$slug")({
  beforeLoad: ({ location }) => {
    const href = publicRedirectPath(location.pathname);
    if (href) throw redirect({ href, replace: true });
  },
  loader: ({ params }) => loadContentPage(`/compare/${params.slug}`),
  head: ({ loaderData }) => contentHead(loaderData),
  component: ContentRoute,
});
function ContentRoute() {
  return <MarketingContentPage page={Route.useLoaderData()} />;
}
